import { c as _c } from "react/compiler-runtime";
import { NotFound } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { TWILIO_PHONE_NUMBERS_PATH } from '../api';
import { TwilioPhoneNumbersListInterface } from '../types';
export function useTwilioPhoneNumbers() {
  const $ = _c(9);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get,
      onNotFound: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: fetchIntegration
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (!user) {
        return;
      }
      return [TWILIO_PHONE_NUMBERS_PATH, RequestModuleEnum.TwilioPhoneNumbers];
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    mutate,
    isLoading,
    isValidating,
    error: error_0
  } = useControlledSwr(t1, fetchIntegration);
  const errorNotFound = error_0 instanceof NotFound ? error_0 : undefined;
  let t2;
  if ($[3] !== data || $[4] !== errorNotFound || $[5] !== isLoading || $[6] !== isValidating || $[7] !== mutate) {
    t2 = {
      data,
      errorNotFound,
      mutate,
      isLoading,
      isValidating
    };
    $[3] = data;
    $[4] = errorNotFound;
    $[5] = isLoading;
    $[6] = isValidating;
    $[7] = mutate;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(error) {
  throw error;
}